<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Lookup'"></Teranet-PageTitle>
    <form (ngSubmit)="onSubmit()"
          [formGroup]="lookupForm"
          novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Lookup Criteria'" [IconName]="'search'"></Teranet-ClientTitle>
            <div fxLayout="row wrap">
              <div [ngClass]="(!lookupForm.get('policyNumber').value || lookupForm.get('policyNumber').value.trim().length === 0) &&
                   (!lookupForm.get('postalCode').value || lookupForm.get('postalCode').value.trim().length === 0)? 'form-group-flex-column' : 'form-group-flex-column grey'">
                <mat-label for="txtPANNumber">Product Account Number</mat-label>
                <mat-form-field appearance="outline">
                  <input (change)="isEnablePANNum()"
                         data-lpignore="true"
                         formControlName="PAN"
                         id="txtPANNumber"
                         matInput
                         type="text" />
                  <mat-error *ngIf="lookupForm.get('PAN').hasError('minlength') || lookupForm.get('PAN').hasError('whitespace')">
                    Account Number must be at least 4 characters long.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Or</mat-label>
              </div>
              <div [ngClass]="(!lookupForm.get('PAN').value || lookupForm.get('PAN').value.trim().length === 0) &&
                   (!lookupForm.get('postalCode').value || lookupForm.get('postalCode').value.trim().length === 0 )? 'form-group-flex-column' : 'form-group-flex-column grey'">
                <mat-label for="txtAccountNumber">Policy Number</mat-label>
                <mat-form-field appearance="outline">
                  <input (change)="isEnablePolicyNum()"
                         data-lpignore="true"
                         formControlName="policyNumber"
                         id="txtPolicyNumber"
                         matInput
                         title="Policy Number"
                         type="text" />
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <mat-label>Or</mat-label>
              </div>
              <div [ngClass]="(!lookupForm.get('PAN').value || lookupForm.get('PAN').value.trim().length === 0) &&
                   (!lookupForm.get('policyNumber').value || lookupForm.get('policyNumber').value.trim().length === 0) ? 'form-group-flex-column' : 'form-group-flex-column grey'">
                <mat-label for="txtAccountNumber">Postal Code</mat-label>
                <mat-form-field appearance="outline">
                  <input (change)="isEnablePostalCode()"
                         data-lpignore="true"
                         formControlName="postalCode"
                         id="txtPostalCode"
                         matInput
                         type="text" />
                </mat-form-field>
              </div>

            </div>
            <div fxLayout="row wrap" fxLayoutAlign="end">
              <button (click)="onClearCriteria()"
                      class="plain-button-lg"
                      mat-raised-button
                      type="reset">
                Clear Criteria
              </button>
              <button [disabled]="isEnableLookupBtn()"
                      class="theme-button-lg"
                      mat-raised-button
                      type="submit">
                Lookup
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff">
    </ngx-spinner>
    <Teranet-CustomizedGrid [data]="lookups"
                            [featureComponentGridSettings]="featureComponentGridSettings"
                            [gridName]="'lookup'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="gridDefaultSettings()"
                            [isFinishLoading]="true"
                            [pageName]="'lookup'"></Teranet-CustomizedGrid>
  </div>
</div>
